import React from "react";
import whatWeDoImage from '../../../resource/image/what-we-do/wd.png'

const WhatWeDoSection = ({ siteConfig }) => {
  return (


      <div className={'py-24 sm:py-32 bg-gray-100'}>

          <div className="mx-auto max-w-7xl px-6 py-16 " id='our-services'>
                  <div
                      className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
                      <div className="lg:max-w-lg">
                          <h4 className="text-main-100 uppercase tracking-widest  sec-head-font"
                              >
                              {siteConfig.what_we_do.label}
                          </h4>
                          <h2 className="text-4xl text-bf-100 mt-2 sec-breif-font ">
                              {siteConfig.what_we_do.title}
                          </h2>
                          <p className="text-dc-100  mt-4 leading-relaxed sec-desc-font">
                              {siteConfig.what_we_do.description}

                          </p>
                      </div>
                      <div className="flex items-start justify-end lg:order-first ">
                          <img
                              src={whatWeDoImage} alt="Modern Bathroom"
                              className="lg:absolute rounded-2xl lg:rounded-l-0 lg:rounded-r-2xl left-0 object-right w-full lg:max-w-xl xl:max-w-2xl xl:-mt-0 2xl:max-w-3xl 2xl:-mt-32"
                              width={2432}
                              height={1442}
                          />

                          {/*/!* Decorative Background Elements *!/*/}
                          {/*<div className="absolute -z-10 top-10 left-10 w-40 h-40 bg-blue-100 rounded-2xl"></div>*/}
                          {/*<div className="absolute -z-10 bottom-10 right-10 w-32 h-32 bg-gray-100 rounded-2xl"></div>*/}


                      </div>
                  </div>
          </div>


          {/*<section className=" mx-auto px-6 py-16 flex flex-col lg:flex-row items-center bg-gray-100" id='our-services'>*/}
          {/*    /!* Left Side - Image *!/*/}
          {/*    <div className="lg:w-1/2 relative">*/}
          {/*        <div className="relative shadow-lg rounded-2xl overflow-hidden right-10">*/}
          {/*            <img*/}
          {/*                src={whatWeDoImage} // Replace with actual image URL*/}
          {/*                alt="Modern Bathroom"*/}
          {/*                className="w-full h-full object-cover"*/}
          {/*            />*/}
          {/*        </div>*/}

          {/*        /!* Decorative Background Elements *!/*/}
          {/*        <div className="absolute -z-10 top-10 left-10 w-40 h-40 bg-blue-100 rounded-2xl"></div>*/}
          {/*        <div className="absolute -z-10 bottom-10 right-10 w-32 h-32 bg-gray-100 rounded-2xl"></div>*/}
          {/*    </div>*/}

          {/*    /!* Right Side - Text *!/*/}
          {/*    <div className="lg:w-1/2 lg:pl-16 mt-10 lg:mt-0 text-left">*/}
          {/*        <h4 className="text-blue-500 uppercase tracking-widest font-normal" style={{color: '#3C86A7'}}>*/}
          {/*            {siteConfig.what_we_do.label}*/}
          {/*        </h4>*/}
          {/*        <h2 className="text-4xl font-bold text-gray-900 mt-2" style={{color: '#383A42'}}>*/}
          {/*            {siteConfig.what_we_do.title}*/}
          {/*        </h2>*/}
          {/*        <p className="text-gray-600 mt-4 leading-relaxed" style={{color: '#818793'}}>*/}
          {/*            {siteConfig.what_we_do.description}*/}

          {/*        </p>*/}
          {/*    </div>*/}
          {/*</section>*/}

      </div>

  )
      ;
};

export default WhatWeDoSection;
